module.exports = __webpack_public_path__ + "img/chinesecompany135.8ff66f91.png";